///<reference path="../common/data-template-base.ts"/>

module Meevo.Components.Controls.SmartMover {

  import Dictionary = _.Dictionary;

  export class ReportManufacturersProdCats extends DataTemplateBase implements IDataTemplate {
    public title: string;
    public allSelectedLabel: string;
    public totalSelectedMessage: string;

    manufacturers: ReportManufacturersCollection;
    productCategories: ReportProductCategoryCollection;

    get collection() {
      return this.manufacturers;
    }

    get leafCollection() {
      return this.productCategories;
    }

    constructor(model: Dictionary<any>, properties: string[], { criteria, dataService }) {
      super(model, properties, criteria);

      this.manufacturers = new ReportManufacturersCollection(this.model[properties[0]], [], { criteria });
      this.productCategories = new ReportProductCategoryCollection(this.model[properties[1]], [], { criteria });

      this.productCategories.setParentCollection(
        this.manufacturers,
        new ManufacturersProdCatStrategy(this.manufacturers, this.productCategories, dataService, { criteria })
      );

      this.title = 'LABEL_PRODUCT_CATEGORY';
      this.allSelectedLabel = 'LABEL_ALL_PRODUCT_CATEGORIES';
      this.totalSelectedMessage = 'LABEL_TOTAL_PRODUCT_CATEGORIES_SELECTED';
    }
  }
}
